/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountSelector_account = {
    readonly name: string;
    readonly userMembership: {
        readonly isDefault: boolean;
    };
    readonly " $fragmentRefs": FragmentRefs<"AccountOptionsDropdown_account">;
    readonly " $refType": "AccountSelector_account";
};
export type AccountSelector_account$data = AccountSelector_account;
export type AccountSelector_account$key = {
    readonly " $data"?: AccountSelector_account$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountSelector_account">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountSelector_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountMembershipResponse",
      "kind": "LinkedField",
      "name": "userMembership",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isDefault",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AccountOptionsDropdown_account"
    }
  ],
  "type": "Account",
  "abstractKey": null
};
(node as any).hash = 'e82e8cafd124702913d8e250cb6e7050';
export default node;
